import { DPTimeSheet } from './dp-timesheet';

export class DPProject {
    project_id: number;
    project_name: string;
    estimated_hours: string;
    start_date: string;
    estimated_end_date: string;
    delivered_date: string;
    status: string;
    account_id: number;
    project_time_sheets: DPTimeSheet[];
    sponsor: string;
    link: string;
    feedback: string;
    sponsored: number;



    constructor() {
        this.project_time_sheets = new Array<DPTimeSheet>();
    }
}




// WEBPACK FOOTER //
// ./src/app/portalv1/model/dp-project.ts